<template>
	<xsend></xsend>
</template>

<script>
	import xsend from '../component/xsend.vue';
	
	export default{
		components:{
			xsend,
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// plisting.vue?c18c8756